import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import { useRuvixxFlags } from "providers/RuvixxFlagsProvider";

export default function useCanReadRegistrantLeads() {
  const { enable_leads_feature } = useRuvixxFlags();
  const isAuthorized = useAuthorized([
    ACL_RELATIONSHIPS.lead.readSwoogoRegistrantLeads,
  ]);
  return Boolean(enable_leads_feature) && isAuthorized;
}
